// Load static fonts
import 'typeface-merriweather';

export const onInitialClientRender = require('./src/gatsby/browser/onInitialClientRender');
// export const onRouteUpdate = require('./src/gatsby/browser/onRouteUpdate');
export { onRouteUpdate } from "./src/gatsby/browser/onRouteUpdate";
export const shouldUpdateScroll = require('./src/gatsby/browser/shouldUpdateScroll');
